import { Button } from "@/shared/components/ui/Button";
import { useNavigate } from "react-router-dom";
export default function ErrorPage() {
	const logoBase64 = localStorage.getItem("whitelabelLogoBase64");
	const whitelabelLogo = localStorage.getItem("whitelabelLogo") ?? "";

	const navigate = useNavigate();

	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-6 text-center">
			<div>
				{logoBase64 || whitelabelLogo ?
					<img src={logoBase64 || whitelabelLogo} alt="Logo" />
				:	""}
			</div>{" "}
			<h1 className="mb-4 text-4xl font-bold text-red-600">Oops!</h1>
			<p className="mb-2 text-lg text-gray-700">Something went wrong.</p>
			<Button className="mt-2" onClick={() => navigate("/login")}>
				Back to Login
			</Button>{" "}
		</div>
	);
}
